import api from "@/config/api";
import { auth } from "@/config/firebase";
import { useUser } from "@/context/user";
import { Forms } from "@/types/form";
import { log } from "@/utils/logger";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";

const useRegister = (startCountdown: () => void) => {
    const setLoading = useUser(state => state.setGlobalLoading);
    const [registered, setRegistered] = useState(false);

    const onRegister = async (data: Forms["Register"]) => {
        try {
            setLoading(true);
            const { email, password } = data;

            await api.post("/users/signup", { data, authenticate: false });
            await signInWithEmailAndPassword(auth, email, password);

            startCountdown();
            setRegistered(true);
            log.success("Thank you for signing up. Your account has been successfully created!");
        } catch (e) {
            log.error(e, "onRegister");
            setRegistered(false);
        } finally {
            setLoading(false);
        }
    };

    const onResendLink = async (email: string) => {
        try {
            await api.post("/users/verify-email", { data: { email }, authenticate: false });
            startCountdown();
        } catch (e) {
            log.error(e, "onResendLink");
        }
    };

    return { onRegister, registered, onResendLink };
};

export { useRegister };
